import { EntityItem } from "../../entity/EntityItem";

export class DtoItemsPostRes extends EntityItem {}
